<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';

	export let showModal = false;

	const dispatch = createEventDispatcher();
</script>

<Modal
	on:close={() => {
		showModal = false;
	}}
	{showModal}
	title={$format('label_exit_device_inclusion_modal', {
		default: 'Exit Device Inclusion?',
	})}
	backdropClose={false}
>
	<Container slot="content" padding="0">
		<Text>
			{$format('text_exit_inclusion_modal', {
				default:
					'Exiting now will stop the device inclusion process and any progress you have made will be lost.',
			})}
		</Text>
	</Container>
	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				showModal = false;
			}}
		>
			{$format('button_resume_inclusion', {
				default: 'Resume inclusion',
			})}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => {
				dispatch('confirm');
			}}
		>
			{$format('button_exit_inclusion', {
				default: 'Exit inclusion',
			})}
		</Button>
	</div>
</Modal>
